<template>
    <div id="classadd">
        <headers title="选择学生"></headers>
        <div class="stu_list">
            <div class="item flex jb ac" v-for="(item,index) in stu_list" :Key="index" @click="choose(item)">
                <p>{{item.real_name }}</p>
                <img :src="active==item.user_id ?require('./img/icon_check.png'): require('./img/icon_nocheck.png')" />
            </div>
        </div>
        <div class="fix_btm" :class="active?'active':''" @click="shure">
            <span>确定</span>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from "COMPONENTS/base/header.vue";
export default {
    components: {
        headers,
    },
    data () {
        return {
            loading: false,
            unit_class_id:this.$route.params.unit_class_id,
            phone:'15225161111',
            stu_list:[],
            active:null,
        }
    },
    created(){
        this.phone= this.$store.state.classmange.searchphone
        if(!this.phone){
            this.$router.go(-1)
        }else{
            this.list()
        }
    },
    methods: {
        list () {
            this.$http.post(API_URL_BASE_API + '/user/list/', {
                phone: this.phone,
                user_type: 1,
            }).then(res => {
                if (res.data.response == 'ok') {
                    res.data.data.forEach(e=>{
                        e.active=false
                    })
                    this.stu_list=res.data.data
                } else {
                    layer.tips(res.data.message)
                }
            })
        },
        choose(item){
            this.active=item.user_id
        },
        shure(){
            if(!this.active){
                return
            }
            this.$http.post(API_URL_BASE_API + '/unit/region/stu/join/class', {
                unit_class_id:this.unit_class_id,
                user_id: this.active
            }).then(res => {
                if (res.data.response == 'ok') {
                    layer.tips(res.data.message)
                    this.$router.go(-2)
                } else {
                    layer.tips(res.data.message)
                }
            })
        }
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.flex {
    display: flex;
}

.jb {
    justify-content: space-between;
}

.ac {
    align-items: center;
}

#classadd {
    padding-bottom: $h-header;
}


.stu_list{
    padding: 32px/$ppr 32px/$ppr 0 32px/$ppr;
    .item{
        background:#fff;
        border-radius: 20px/$ppr;
        border:1px/$ppr solid #999;
        padding:20px/$ppr 32px/$ppr;
        margin-bottom: 32px/$ppr;
        p{
            font-size: 28px/$ppr;
        }
        img{
            width: 34px/$ppr;
            height: 34px/$ppr;
        }
    }
}
.fix_btm{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding:16px/$ppr 32px/$ppr;
    box-sizing: border-box;
    span{
        display: block;
        background: #eaeaea;
        height: 72px/$ppr;
        line-height: 72px/$ppr;
        border-radius: 72px/$ppr;
        color: #999;
        font-size: 28px/$ppr;
        text-align: center;
    }
    &.active{
        span{
            background: #5e89ef;
            color: #fff;
        }
    }
}
</style>